<!--  title -->
<template>
  <div class="title">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'sub-title-qa'
}
</script>
<style lang="stylus" scoped>

.title
  font-family  fonts!important
  font-size $font-size!important
  text-align left
  line-height: 1.3!important;
  color: $info-color
  font-weight bolder!important
  margin-bottom: 20px;

</style>
